import { call, put, takeEvery } from "redux-saga/effects"

import { GET_ROLE_PERMISSIONS, ADD_NEW_ROLE_PERMISSION, UPDATE_ROLE_PERMISSION, DELETE_ROLE_PERMISSION } from "./actionTypes";
import {
    getRolePermissionsSuccess,
    getRolePermissionsFail,
    addRolePermissionSuccess,
    addRolePermissionFail,
    updateRolePermissionSuccess,
    updateRolePermissionFail,
    deleteRolePermissionSuccess,
    deleteRolePermissionFail,
   
} from "./actions"

import {
    getRolePermissions,
    addNewRolePermission,
    updateRolePermission,
    deleteRolePermission,
   
} from "helpers/role-permissions/role_permissions_backend_helper";
import { toast } from "react-toastify";

function* fetchRolePermissions() {
    try {
        const response = yield call(getRolePermissions)

        console.log("RESPONSE: ", response);
        yield put(getRolePermissionsSuccess(response))
    } catch (error) {
        yield put(getRolePermissionsFail(error))
    }
}

function* onAddNewRolePermission({ payload: data }) {
    try {
        const response = yield call(addNewRolePermission, data)
        yield put(addRolePermissionSuccess(response))
        toast.success("PERMISSION  Added Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(addRolePermissionFail(error))
        toast.error("PERMISSION  Added Failed", { autoClose: 2000 });
    }
}

function* onUpdateRolePermission({ payload: data }) {
    try {
        console.log("UPDATE" , data);
        const response = yield call(updateRolePermission, data)

        
        yield put(updateRolePermissionSuccess(response))
        toast.success("PERMISSION  Updated Successfully", { autoClose: 2000 });
    } catch (error) {

        console.log("ERROR: ", error);
        yield put(updateRolePermissionFail(error))
        toast.error("PERMISSION  Updated Failed", { autoClose: 2000 });
    }
}

function* onDeleteRolePermission({ payload: data }) {

    try {
        const response = yield call(deleteRolePermission, data)
        yield put(deleteRolePermissionSuccess(response))
        toast.success("PERMISSION  Deleted Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(deleteRolePermissionFail(error))
        toast.error("PERMISSION  Deleted Failed", { autoClose: 2000 });
    }
}


function* rolePermissionSaga() {
    yield takeEvery(GET_ROLE_PERMISSIONS, fetchRolePermissions)
    yield takeEvery(ADD_NEW_ROLE_PERMISSION, onAddNewRolePermission)
    yield takeEvery(UPDATE_ROLE_PERMISSION, onUpdateRolePermission)
    yield takeEvery(DELETE_ROLE_PERMISSION, onDeleteRolePermission)
}

export default rolePermissionSaga;